module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_onboard_whatsapp-f901ff6b5c40fc8a82b979d5df16377a.svg";